import { Component } from 'react';
import {
    Avatar,
    Box,
    FormControl,
    MenuItem,
    Select,
    Typography
} from '@mui/material';

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL;

class CharacterSelect extends Component {
  constructor(props) {
    super(props);
    const defaultValue = this.props.player
      ? this.props.player.characterId || ""
      : "";
    this.state = { value: defaultValue };
    this.id = props.id;
    this.characters = props.characters;

    if (this.props.onChange && defaultValue) {
        this.props.onChange(defaultValue);
    }
  }

  handleCharacterSelect = (e) => {
    const value = e.target.value;

    // Update local state
    this.setState({ value });

    // Notify parent of the selection change
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  render() {
    const { value } = this.state;

    return (
      <FormControl fullWidth>
        <Select
          labelId={`character-select-${this.id}`}
          id={`character-select-${this.id}`}
          value={value}
          displayEmpty
          variant="outlined"
          inputProps={{ MenuProps: { disableScrollLock: true } }}
          onChange={this.handleCharacterSelect}
          sx={{
            fontSize: "12px",
            fontWeight: "bold",
            height: "60px",
            backgroundColor: value
              ? this.characters[parseInt(value) - 1]?.startColor || "white"
              : "white",
          }}
        >
          {/* Placeholder MenuItem */}
          <MenuItem value="" disabled>
            <Typography fontWeight="bold" color="gray">
              Character
            </Typography>
          </MenuItem>

          {/* List of characters */}
          {this.characters
            ?.filter((character) => character.name !== "Beeg Yoshi")
            .map((character) => (
              <MenuItem
                value={character.id}
                key={`player-${this.id}-character-key-${character.id}`}
                sx={{ backgroundColor: character.startColor }}
              >
                <Box display="flex" alignItems="center">
                  <Avatar
                    src={`${IMAGE_URL}${this.characters[parseInt(character.id) - 1]?.rosterUrl}`}
                    alt={character.name}
                    sx={{ marginLeft: { xs: 0, md: 1 } }}
                  />
                  <Typography
                    sx={{
                      ml: { xs: 1, md: 4 },
                      color: "white",
                      fontWeight: "bold",
                      display: "inline",
                    }}
                  >
                    {character.name}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }
}

export default CharacterSelect;
